<template>
    <Dropdown
        class="profile-widget"
        :popper-options="{
            modifiers: {
                offset: {
                    offset: '-30,0',
                    enabled: true,
                },
            },
        }"
    >
        <template #label>
            <button type="button" class="profile-widget__label">
                <div class="profile-widget__userpic">
                    <img v-if="userpic" :src="userpic" class="profile-widget__image" />
                    <div v-else class="profile-widget__empty">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 70 70"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M56.0163 50.0372L44.8712 44.4652C43.82 43.939 43.1667 42.882 43.1667 41.706V37.7615C43.4338 37.4348 43.715 37.0627 44.0055 36.652C45.451 34.6103 46.6095 32.3377 47.4518 29.8865C49.098 29.1317 50.1667 27.5042 50.1667 25.6667V21C50.1667 19.8765 49.7467 18.788 49 17.9375V11.732C49.0653 11.0903 49.322 7.27067 46.5593 4.1195C44.163 1.386 40.2745 0 35 0C29.7255 0 25.837 1.386 23.4407 4.11833C20.678 7.2695 20.9347 11.0903 21 11.732V17.9375C20.2534 18.788 19.8334 19.8765 19.8334 21V25.6667C19.8334 27.0865 20.4785 28.4107 21.5799 29.2938C22.6485 33.5253 24.885 36.7138 25.6667 37.737V41.5975C25.6667 42.7268 25.0507 43.7628 24.0602 44.3042L13.6524 49.9812C10.2679 51.828 8.16669 55.3677 8.16669 59.2223V63C8.16669 68.537 25.7192 70 35 70C44.2808 70 61.8333 68.537 61.8333 63V59.4498C61.8333 55.4388 59.6038 51.8315 56.0163 50.0372ZM59.5 63C59.5 64.5832 50.8527 67.6667 35 67.6667C19.1474 67.6667 10.5 64.5832 10.5 63V59.2223C10.5 56.2228 12.1357 53.466 14.7689 52.031L25.1767 46.354C26.9185 45.4032 28 43.5797 28 41.5975V36.9087L27.7282 36.5843C27.7002 36.5505 24.8407 33.0913 23.7499 28.3418L23.6437 27.8798L23.2459 27.6232C22.5704 27.1868 22.1667 26.4553 22.1667 25.6667V21C22.1667 20.3455 22.4444 19.7353 22.9484 19.2792L23.3334 18.9327V11.6667L23.3229 11.5138C23.3194 11.4823 22.9227 8.24833 25.1954 5.656C27.1285 3.451 30.4279 2.33333 35 2.33333C39.5558 2.33333 42.8482 3.44283 44.7837 5.63267C47.0552 8.2005 46.6795 11.4858 46.6772 11.5138L46.6667 18.9327L47.0517 19.2803C47.5557 19.7353 47.8333 20.3455 47.8333 21V25.6667C47.8333 26.6852 47.166 27.5765 46.1743 27.8822L45.5933 28.0607L45.4067 28.6382C44.6262 31.066 43.5143 33.3083 42.1003 35.3033C41.7538 35.7945 41.4167 36.2297 41.1238 36.5622L40.8334 36.8935V41.706C40.8334 43.771 41.9802 45.6272 43.827 46.5512L54.9722 52.1232C57.7652 53.5197 59.5 56.3267 59.5 59.4498V63Z"
                                fill="#eee"
                            />
                        </svg>
                    </div>
                </div>
            </button>
        </template>
        <template #items>
            <router-link v-slot="{ navigate }" custom to="/profile">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('misc.profile') }}
                </li>
            </router-link>
            <!-- @todo refactor this. this is a place for navigation but not through this component.
                    needs slot/portal or whatever -->
            <template v-if="!$isCrmApp">
                <WithGroupAccess allowed="administrators,staff">
                    <router-link v-slot="{ navigate }" custom to="/contracted">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            Contracted Books
                        </li>
                    </router-link>
                </WithGroupAccess>
                <WithGroupAccess allowed="administrators,staff">
                    <router-link v-slot="{ navigate }" custom to="/phonemes">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            Phonemes
                        </li>
                    </router-link>
                </WithGroupAccess>
                <WithGroupAccess v-if="!$isClientApp" allowed="administrators,staff">
                    <router-link v-slot="{ navigate }" custom to="/dictionary">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            Vocabulary
                        </li>
                    </router-link>
                </WithGroupAccess>
                <WithGroupAccess v-if="!$isClientApp" allowed="administrators,staff">
                    <router-link v-slot="{ navigate }" custom to="/special_symbols">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            Special Symbols
                        </li>
                    </router-link>
                </WithGroupAccess>
                <WithGroupAccess v-if="$isManageApp" allowed="administrators,staff">
                    <router-link v-slot="{ navigate }" custom to="/speakers">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            Voices
                        </li>
                    </router-link>
                </WithGroupAccess>
            </template>
            <template v-else>
                <router-link v-slot="{ navigate }" custom to="/orders">
                    <li class="dropdown__item dropdown__item--link" @click="navigate">Orders</li>
                </router-link>
                <WithGlobalPermission v-if="!isInnerWorkspace" permission="Customer.list">
                    <router-link
                        v-slot="{ navigate }"
                        custom
                        :to="{ name: 'customers-id', params: { id: workspaceCustomerId } }"
                    >
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            Settings
                        </li>
                    </router-link>
                </WithGlobalPermission>
                <WithGlobalPermission v-if="isAdmin" permission="Customer.list">
                    <router-link v-slot="{ navigate }" custom :to="{ name: 'global-settings' }">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            {{ isInnerWorkspace ? 'Settings' : 'Global settings' }}
                        </li>
                    </router-link>
                </WithGlobalPermission>
                <WithGlobalPermission permission="OrderTransitionApprovalMeta.list">
                    <router-link v-slot="{ navigate }" custom :to="{ name: 'transitions' }">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">
                            {{ $t('crm.transitions.menuItem') }}
                        </li>
                    </router-link>
                </WithGlobalPermission>
                <WithGlobalPermission permission="OrderFlow.list">
                    <router-link v-slot="{ navigate }" custom :to="{ name: 'flows' }">
                        <li class="dropdown__item dropdown__item--link" @click="navigate">Flows</li>
                    </router-link>
                </WithGlobalPermission>
            </template>
            <li class="dropdown__item dropdown__item--link" @click="logout">
                {{ $t('misc.logout') }}
            </li>
        </template>
    </Dropdown>
</template>

<script>
import Dropdown from '@speechki-frontend/shared/ui/Dropdown';
import { WithGroupAccess, WithGlobalPermission } from '@speechki-frontend/core/auth/components';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'ProfileWidget',
    components: {
        Dropdown,
        WithGroupAccess,
        WithGlobalPermission,
    },
    computed: {
        ...mapState('workspaces', ['activeWorkspace']),
        ...mapGetters('workspaces', ['workspaceCustomerId', 'isInnerWorkspace']),
        ...mapGetters(['isAdmin']),
        userpic() {
            return this.$store.state.auth.user.photo;
        },
    },
    methods: {
        async logout() {
            await this.$store.dispatch('logout');
            localStorage.removeItem('lastroute');
            if (this.$disconnect) {
                this.$disconnect();
            }
            this.$router.push({ name: 'login' });
        },
    },
};
</script>

<style lang="scss" src="./ProfileWidget.scss"></style>
